import { Button } from 'antd';
import { BulbOutlined } from '@ant-design/icons';
import { useAiAgent } from '@/contexts/AiAgentContext';
import { intelligenceService } from '@/services/intelligence.service';

/** One-click Explain on detail pages — opens sidebar + audits explain. */
export function ExplainIntelligenceButton(props?: { size?: 'small' | 'middle' }) {
  const { openExplain, pageContext, setIntelligenceSidebarOpen } = useAiAgent();

  return (
    <Button
      size={props?.size || 'small'}
      icon={<BulbOutlined />}
      onClick={() => {
        setIntelligenceSidebarOpen(true);
        openExplain();
        void intelligenceService.explain(pageContext).catch(() => undefined);
      }}
    >
      Explain
    </Button>
  );
}
